import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Masonry from 'masonry-layout';

class Work extends Component {
    constructor() {
        super();
        this.generatedPos = [];
        this.desktop = window.innerWidth > 768;
        this.updateDimensions = this.updateDimensions.bind(this);
        this.state = {
            projectsList: <div />,
            filterExpanded: false,
            dataReady: false
        };
    }

    componentDidUpdate() {
        // another way to force layout
        var elem = document.querySelector('.random-layout');
        this.msnry = new Masonry(elem, {});
    }

    componentDidMount() {
        this.constructProjectLayout();
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    rand(min, max) {
        return Math.random() * (max - min + 1) + min;
    }

    constructProjectLayout() {
        this.generatedPos = this.props.projects.map((proj, i) => {
            return {
                width: this.rand(25, 30),
                paddingLeft: this.rand(0, 40),
                paddingRight: this.rand(0, 40),
                paddingTop: this.rand(0, 50)
            }
        });
        console.log(this.props.projects, this.generatedPos);
        this.makeProjectList(this.props.projects);
        this.setState({ dataReady: true });
    }

    makeProjectList(projects) {
        const desktop = this.desktop;
        const mult = this.getDesktopState();
        const projectsList = projects.map((proj, i) => {
            const path = "/work/" + proj.slug;
            const projI = "proj-" + i;
            const imgParams = proj.images[0].imgType === "jpg" ? "&w=560" : "";
            const projstyle = {
                width: desktop === true ? this.generatedPos[i].width + "%" : "100%",
                height: desktop === true ? "auto" : "200px",
                paddingLeft: desktop === true ? (this.generatedPos[i].paddingLeft * mult / 3) : 0,
                paddingRight: desktop === true ? (this.generatedPos[i].paddingRight * mult / 3) : 0,
                paddingTop: desktop === true ? (this.generatedPos[i].paddingTop * mult / 2) : 0
            }
            return <div key={i} className="project" style={projstyle} id={projI}>
              <Link to={path} className="thumbimglink" style={{backgroundImage: `url(${proj.images[0].url + imgParams})`}} >
                  <div className="project-title">
                        <p>{proj.title}</p>
                  </div>
                  <img src={proj.images[0].url + imgParams} key={i} alt="" className="thumbimg" onLoad={this.handleImgLoaded.bind(this)}/>
              </Link>
            </div>;
        });
        this.setState({ projectsList });
    }

    getDesktopState() {
        const w = window.innerWidth;
        // also CSS for break points
        if (w < 560) {
            return 0;
        } else if (w > 560 && w < 1024) {
            return 1;
        } else {
            return 2; }
    }

    updateDimensions() {
        this.desktop = window.innerWidth > 768;
        this.makeProjectList(this.props.projects);
    }

    handleImgLoaded() {
        // after msnry is created force layout after every image is loaded
        this.msnry.layout();
    }

    filterCat(e) {
        const cat = e.target.getAttribute("data-cat");
        let filteredProjects = this.props.projects;
        if (cat === "all") {
            this.setState({ filterExpanded: !this.state.filterExpanded });
        } else {
            filteredProjects = this.props.projects.filter((item) => {
                const lowerCaseCategories = item.category.map(o => o.toLowerCase());
                return lowerCaseCategories.indexOf(cat) > -1;
            });
        }
        this.makeProjectList(filteredProjects);
    }


    render() {
        const plusClass = this.state.filterExpanded ? "" : "plus";
        const filterClass = this.state.filterExpanded ? "filter-category show-filter" : "filter-category";
        const filterList = this.props.categories.map((o, i)=>{
            return <div key={i} className={filterClass} onClick={this.filterCat.bind(this)} data-cat={o.toLowerCase()}>{o}</div>;
        });

        return (
            <div className="content">
              <div className="random-layout">
                <div className="project-grid-sizer" />
                <div className="stamp">
                  <div className={plusClass} id="toggleExpand" onClick={this.filterCat.bind(this)} data-cat="all"></div>
                  {filterList}
                </div>
                {this.state.dataReady && this.state.projectsList}
              </div>
          </div>
        );
    }
}

export default Work;



// WEBPACK FOOTER //
// ./src/components/Work.js